import { type MetricField } from "../../gql-generated/types";
import { formatSignedPctNumber } from "../../lens-stats/formatters";
import { getKeys } from "../../shared/utils/object";
import { getInsightsDiffPct } from "../math";
import { type InsightsMetrics, type InsightsMetricsMap, type StatsItem } from "../models";

export const mapDiffValues = (
    metrics: Partial<Record<MetricField, InsightsMetrics<StatsItem>>>,
    metricsPrevious: InsightsMetricsMap<StatsItem>,
): InsightsMetricsMap<StatsItem> => {
    getKeys(metrics).forEach((item: MetricField) => {
        const metric = metrics[item];
        if (metric) {
            const diffValue = getInsightsDiffPct(metric.totalValue, metricsPrevious[item]?.totalValue ?? 0);
            metric.diffValue = formatSignedPctNumber(diffValue);
        }
    });

    return metrics;
};
